import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IPaymentCardsFeature } from './payment-cards.feature.state';
import { PaymentCardsState } from './payment-cards.state';

export const getPaymentCardsState: MemoizedSelector<IPaymentCardsFeature, PaymentCardsState> = createFeatureSelector<PaymentCardsState>(
  nameof<IPaymentCardsFeature>('paymentCardsFeature')
);

export const getPaymentCards = createSelector(getPaymentCardsState, (state: PaymentCardsState) => state.paymentCards);

export const isLoading = createSelector(getPaymentCardsState, (state: PaymentCardsState) => state.isLoading);

export const failures = createSelector(getPaymentCardsState, (state: PaymentCardsState) => state.failures);

export const getCanPay = createSelector(getPaymentCardsState, (state: PaymentCardsState) => state.canPay);

export const getSelectedPaymentCard = createSelector(getPaymentCardsState, (state: PaymentCardsState) => state.selectedPaymentCard);
export const getDeletedPaymentCardResponse = createSelector(getPaymentCardsState, (state: PaymentCardsState) => state.deletedPaymentSuccess);
